/**
 * @generated SignedSource<<20d58b83b05f42ad82a3d2a8318209b4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedAsyncModules_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedPersonalizedSearchItems_user" | "SharedRecentSales_user" | "SharedYMAL_user">;
  readonly " $fragmentType": "BuySharedAsyncModules_user";
};
export type BuySharedAsyncModules_user$key = {
  readonly " $data"?: BuySharedAsyncModules_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedAsyncModules_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedAsyncModules_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentSales_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedYMAL_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedPersonalizedSearchItems_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f740289dffb3e392ee043feecc55d897";

export default node;
